import get from 'lodash.get';

const getPartnerName = (rootState) => get(rootState, 'partner.name');

export default getPartnerName;
